import { axios } from "../../../../../../Global";
import nodeinstance from "../../../../../../nodeInstance";
import { setAppError } from "../../../../../../store/userSlice";
import { sortByName } from "../../../../../../utils/sortByName";

const token = localStorage.getItem("token");

export const statusArray = [
  "MEDICALLY UNFIT",
  "BACKED OUT",
  "UNDER PROCESS FOR VISA STAMP",
  "SELECTED",
  // "VISA STAMPED",
];

export const religionArray = ["MUSLIM", "NON MUSLIM"];
export const durationOfContractArray = ["6 MONTHS", "12 MONTHS", "24 MONTHS"];
export const probationPeriodArray = ["3 MONTHS", "6 MONTHS", "9 MONTHS"];
export const bloodGroupArray = [
  "A+",
  "B+",
  "AB+",
  "AB-",
  "O+",
  "O-",
  "A-",
  "B-",
];
export const covidVaccineArray = ["DOSE 1", "DOSE 2"];

export const fetchCandidateList = async (
  projectId,
  setCandidateListData,
  setLoading,
  dispatch
) => {
  setLoading(true);
  try {
    const res = await axios.get(
      `/dashboard/project-candidates-list/${projectId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.status == 200) {
      const state = res.data.data;
      setArrayValues(state, setCandidateListData);
      setLoading(false);
      // setCandidateListData(res.data.data);
    }
  } catch (error) {
    console.log("error....tobe...........", error);
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
  }
};
export const putGroupEdit = async (
  projectId,
  body,
  setCandidateListData,
  setLoading,
  dispatch
) => {
  setLoading(true);
  try {
    const res = await axios.put(
      `/dashboard/project-candidates/${projectId}`,
      { candidate: body },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (res.status == 200) {
      const state = res.data.data;
      setArrayValues(state, setCandidateListData);
      setLoading(false);
      dispatch(setAppError({ msg: res.data.message, color: "success" }));
    }
    return { completed: true, error: false };
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
    return { completed: true, error: true };
  }
};
export const deleteGroupDelete = async (
  projectId,
  body,
  setCandidateListData,
  setLoading,
  dispatch
) => {
  setLoading(true);
  try {
    // const res = await fetch(
    //   `https://api-laravel.sla.live/api/v1/dashboard/project-candidates/${projectId}`,
    //   {
    //     method: "DELETE",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //     body: JSON.stringify(body),
    //   }
    // );
    const res = await axios.delete(`/dashboard/project-candidates/${projectId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.status == 200) {
      const responseData = await res.json();
      const state = responseData.data;
      setArrayValues(state, setCandidateListData);
      setLoading(false);
      dispatch(setAppError({ msg: responseData.message, color: "success" }));
    }
    return { completed: true, error: false };
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
    return { completed: true, error: true };
  }
};

// export const deleteRowDelete = async (
//   projectId,
//   body,
//   setCandidateListData,
//   dispatch
// ) => {
//   try {
//     alert("trigger.....");
//     const response = await fetch(
//       `https://api-laravel.sla.live/api/v1/dashboard/project-candidates/${projectId}`,
//       {
//         method: "DELETE",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(body),
//       }
//     );

//     if (response.status === 200) {
//       const data = await response.json();
//       dispatch(setAppError({ msg: data.message, color: "success" }));
//       setArrayValues(data?.data, setCandidateListData);
//       // setCandidateListData(data.data);
//     }
//     return { completed: true, error: false };
//   } catch (error) {
//     if (error?.response?.data?.message) {
//       dispatch(setAppError({ msg: error?.response?.data?.message }));
//     } else {
//       dispatch(setAppError({ msg: error?.message }));
//     }
//     return { completed: true, error: true };
//   }
// };

export const deleteRowDelete = async (
  projectId,
  body,
  setCandidateListData,
  dispatch
) => {
  try {
    alert("trigger.....");

    const response = await axios.delete(
      `/dashboard/project-candidates/${projectId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Ensure token is defined
        },
        data: body, // Axios uses `data` for the request body in DELETE
      }
    );

    if (response.status === 200) {
      const data = response.data;
      dispatch(setAppError({ msg: data.message, color: "success" }));
      setArrayValues(data?.data, setCandidateListData);
    }

    return { completed: true, error: false };
  } catch (error) {
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong!";
    dispatch(setAppError({ msg: errorMsg }));
    return { completed: true, error: true };
  }
};

//update-flight-details
let nodeToken = localStorage.getItem("nodeToken");
export const postAddFlightDetails = async ({
  body,
  setLoading,
  setCandidateListData,
  dispatch,
}) => {
  setLoading(true);
  try {
    const res = await axios.post(
      `/dashboard/project/update-arrival-candidate`,
      body
    );
    if (res.status == 200) {
      const state = res.data.data;
      setArrayValues(state, setCandidateListData);
      setLoading(false);
      dispatch(setAppError({ msg: res.data.message, color: "success" }));
    }
    return { completed: true, error: false };
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
    return { completed: true, error: true };
  }
};

export const setArrayValues = (state, setState) => {
  try {
    const candidatesArray = state?.candidates;

    const nationalityArray = sortByName(state?.nationality);
    const jobPositionArray = sortByName(state?.job_possition);
    const visaProfessionArray = sortByName(state?.visa_profession);
    const sectorArray = sortByName(state?.sector);
    const updatedCandidatesArray = [];
    for (let candidate of candidatesArray) {
      const updatedCandidates = { ...candidate };
      updatedCandidates.nationality_name =
        nationalityArray?.find((data) => data?.id == candidate?.nationality_id)
          ?.name || null;
      updatedCandidates.job_position_name =
        jobPositionArray?.find((data) => data?.id == candidate?.job_position_id)
          ?.name || null;
      updatedCandidates.visa_profession_name =
        visaProfessionArray?.find(
          (data) => data?.id == candidate?.visa_profession_id
        )?.name || null;
      updatedCandidates.sector_name =
        sectorArray?.find((data) => data?.id == candidate?.sector_id)?.name ||
        null;

      updatedCandidatesArray.push(updatedCandidates);
    }

    const flattenArray = flattenObjectsInArray(updatedCandidatesArray);
    setState({
      ...state,
      candidates: flattenArray,
      nationality: nationalityArray,
      job_possition: jobPositionArray,
      visa_profession: visaProfessionArray,
      sector: sectorArray,
    });
  } catch (error) {
    console.log(error);
  }
};

export const updateDefaultFieldsArray = ({
  candidateData,
  removeList = [],
  options = [],
  order = [],
}) => {
  const initialArray = [
    {
      id: 1,
      title: "Employee Name",
      value: "name",
      default: true,
      width: "min-w-[10rem]",
    },
    {
      id: 2,
      title: "Passport No.",
      value: "passport_number",
      default: true,
    },
    {
      id: 3,
      title: "Actual Profession",
      value: "job_position_name",
      width: "min-w-[12rem]",
      default: true,
      optionsArray: candidateData?.job_possition?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 4,
      title: "Nationality",
      value: "nationality_name",
      default: true,
      optionsArray: candidateData?.nationality?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 5,
      title: "Religion",
      value: "religion",
      optionsArray: religionArray,
      filter: true,
      default: true,
    },

    {
      id: 6,
      title: "Candidate Status",
      value: "status",
      optionsArray: statusArray,
      filter: true,
      default: true,
    },
    {
      id: 7,
      title: "VISA Profession",
      value: "visa_profession_name",
      optionsArray: candidateData?.visa_profession?.map((data) => data?.name),
      filter: true,
      default: true,
    },

    {
      id: 10,
      title: "Blood Group",
      value: "blood_group",
      optionsArray: bloodGroupArray,
      filter: true,
    },
    {
      id: 11,
      title: "Sector",
      value: "sector_name",
      optionsArray: candidateData?.sector?.map((data) => data?.name),
      filter: true,
    },
    {
      id: 12,
      title: "Covid Vaccine",
      value: "covid_vaccine",
      optionsArray: covidVaccineArray,
      filter: true,
    },
    {
      id: 13,
      title: "Duration of Contract",
      value: "duration_of_contract",
      optionsArray: durationOfContractArray,
      filter: true,
    },
    {
      id: 14,
      title: "Probation Period",
      value: "probation_period",
      optionsArray: probationPeriodArray,
      filter: true,
    },
    {
      id: 15,
      title: "Selection Date",
      value: "selection_date",
      filter: true,
      filterType: "date",
    },
    {
      id: 16,
      title: "Visa Stamping Date",
      value: "visa_stamping_date",
      default: true,
    },
    {
      id: 17,
      title: "Visa Reference Number",
      value: "visa_reference_number",
      default: true,
    },
    {
      id: 18,
      title: "Visa Block Number",
      value: "visa_block_number",
      default: true,
    },
    {
      id: 19,
      title: "Employee Id",
      value: "candidate_id",
      default: true,
      width: "min-w-[12rem]",
    },
    {
      id: 20,
      title: "Travelling Instance",
      value: "not_travelled_instance",
      width: "min-w-[12rem]",
      default: false,
    },
  ];

  if (candidateData?.candidates?.length > 0) {
    const currentData = candidateData?.candidates[0] || sampleCandidate;
    for (let key in currentData) {
      console.log(key, "alkakldf");
      if (!initialArray.find((data) => data?.value == key)) {
        let title = String(key).split("_").join(" ").toUpperCase();
        title = title
          .replace("CANDIDATE FLIGHT", "")
          .replace("CANDIDATE FILE", "")
          .trim();
        const obj = {
          id: Math.floor(Math.random() * 10000),
          title: title,
          value: key,
          width: String(title)
            .split(" ")
            .find((titleData) => titleData.length > 9)
            ? "min-w-[12rem]"
            : "min-w-[8rem]",
        };
        initialArray.push(obj);
      }
    }
  }

  const removeListArray = [
    "id",
    "project_id",
    "created_at",
    "updated_at",
    "sector_id",
    "nationality_id",
    "job_position_id",
    "visa_profession_id",
    "sponsor_id",
    "company_id",
    "arrival_date",
    "candidate_file",
    "candidate_flight",
    "candidate_flight_created_at",
    "candidate_flight_updated_at",
    "candidate_flight_id",
    "candidate_flight_sector_id",
    "candidate_file_id",
    "candidate_file_candidate_id",
    "candidate_file_created_at",
    "candidate_file_updated_at",
    ...removeList,
  ];

  const filteredArray = initialArray.filter(
    (data) => !removeListArray.includes(data.value)
  );

  const mappedArray = filteredArray.map((item) => {
    const optionItem = options.find(
      (option) =>
        option.value === item.value ||
        new RegExp(`^${option.startingWith}`).test(item.value)
    );

    if (optionItem) {
      // Merge properties from optionItem into the current item
      return { ...item, ...optionItem, value: item.value };
    }

    return item;
  });

  const deleteHideObject = mappedArray.filter((data) => !data?.hide);

  const defaultTrueArray = deleteHideObject.map((item) => {
    if (order.includes(item.value)) return { ...item, default: true };
    else return { ...item, default: false };
  });
  const sortedArray = defaultTrueArray.sort((a, b) => {
    const aValue = order.indexOf(a.value);
    const bValue = order.indexOf(b.value);
    // Handle the case where a value is not present in orderArray
    if (aValue === -1 && bValue === -1) {
      return 0; // No change in order for values not in orderArray
    } else if (aValue === -1) {
      return 1; // Move items not in orderArray to the end
    } else if (bValue === -1) {
      return -1; // Move items not in orderArray to the end
    }
    return aValue - bValue;
  });

  return sortedArray;
};

// export const flattenObjectsInArray = (arr) => {
//   return arr.map((item) => {
//     const flattenedObject = { ...item };

//     const flatten = (obj, prefix = "") => {
//       for (let key in obj) {
//         if (typeof obj[key] === "object") {
//           for (let nestedKey in obj[key]) {
//             flattenedObject[`${key}_${nestedKey}`] = obj[key][nestedKey];
//           }
//         }
//       }
//     };

//     flatten(flattenedObject);

//     return flattenedObject;
//   });
// };

export function flattenObjectsInArray(arr) {
  const flattenedArray = [];

  arr.forEach((obj) => {
    const result = {};

    function flattenObject(obj, parentKey = "") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let newKey = parentKey ? `${parentKey}_${key}` : key;

          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[newKey] = obj[key];
            flattenObject(obj[key], newKey);
          } else {
            result[newKey] = obj[key];
          }
        }
      }
    }

    flattenObject(obj);
    flattenedArray.push(result);
  });

  return flattenedArray;
}

const sampleCandidate = {
  id: 45,
  candidate_id: "2LP6866",
  project_id: 2,
  sector_id: 19,
  selection_date: "11-Jan-2023",
  religion: "MUSLIM",
  name: "JOHN COHEN",
  nationality_id: 1,
  job_position_id: 9,
  visa_profession_id: null,
  approval_remark: "ALIAS ET ACCUSAMUS D",
  passport_number: "EST VEL ILLO SAEPE",
  dob: "24-Aug-1972",
  age: "17",
  selection_grade: "AUTE VOLUPTATUM NEQU",
  basic: "53",
  food: "6",
  fixed_ot: "90",
  hra: "7",
  travel_allowance: "47",
  mobile_allowance: "66",
  air_ticket_allowance: "71",
  additional_ot: "86",
  other_allowance: "39",
  duty_hours: "91",
  fixed_ot_hours: "36",
  duration_of_contract: "6 MONTHS",
  probation_period: "6 MONTHS",
  passport_issue_date: "21-May-1992",
  passport_expiry_date: "11-Mar-1982",
  emergency_contact_person_in_home_country: "SED PROVIDENT NUMQU",
  emergency_contact_number_in_home_country: "40",
  covid_vaccine: "DOSE 2",
  blood_group: "A-",
  status: "TRAVELLING",
  arrival_date: null,
  visa_block_number: null,
  visa_reference_number: null,
  visa_stamping_date: null,
  company_id: null,
  sponsor_id: null,
  candidate_flight_id: 1,
  loan_advance: "5",
  loan_advance_installment: "1",
  not_travelled_instance: 0,
  visa_cancelled_comments: null,
  created_at: "2023-12-05T07:22:50.000000Z",
  updated_at: "2023-12-12T11:19:44.000000Z",
  candidate_file: {
    id: 2,
    candidate_id: 45,
    passport:
      "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_PASSPORT_13-Nov-2023-15-34-53.pdf",
    visa: "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_VISA_13-Nov-2023-15-34-55.pdf",
    vaccine:
      "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_VACCINE_13-Nov-2023-15-34-54.pdf",
    driving_license:
      "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_DRIVINGLICENSE_13-Nov-2023-15-34-53.pdf",
    signed_employee_contract:
      "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_SIGNED_EMP_CONTRACT_13-Nov-2023-15-34-54.pdf",
    signed_absent_policy:
      "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_SIGNED_ABSENT_POLICY_13-Nov-2023-15-34-54.pdf",
    status: "Completed",
    created_at: "2023-11-09T11:47:08.000000Z",
    updated_at: "2023-11-13T12:34:55.000000Z",
  },
  candidate_file_id: 2,
  candidate_file_candidate_id: 45,
  candidate_file_passport:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_PASSPORT_13-Nov-2023-15-34-53.pdf",
  candidate_file_visa:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_VISA_13-Nov-2023-15-34-55.pdf",
  candidate_file_vaccine:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_VACCINE_13-Nov-2023-15-34-54.pdf",
  candidate_file_driving_license:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_DRIVINGLICENSE_13-Nov-2023-15-34-53.pdf",
  candidate_file_signed_employee_contract:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_SIGNED_EMP_CONTRACT_13-Nov-2023-15-34-54.pdf",
  candidate_file_signed_absent_policy:
    "https://slgportal2023.s3.eu-north-1.amazonaws.com/sla/candidate/file/DZP4DKDD2BQBILJU_SIGNED_ABSENT_POLICY_13-Nov-2023-15-34-54.pdf",
  candidate_file_status: "Completed",
  candidate_file_created_at: "2023-11-09T11:47:08.000000Z",
  candidate_file_updated_at: "2023-11-13T12:34:55.000000Z",
  candidate_flight: {
    id: 1,
    flight_details: "AIR-INDIA-111",
    country: "INDIA",
    date_of_departure: "16-Dec-2023",
    time_of_departure: "22:12",
    date_of_arrival: "17-Dec-2023",
    time_of_arrival: "09:30",
    pax: 1,
    sector_id: 11,
    pickup_to_be_arranged: "SLA",
    project_incharge: "Arun",
    flight_status: "asasas",
    created_at: "2023-12-04T10:33:43.000000Z",
    updated_at: "2023-12-12T11:15:35.000000Z",
    sector: {
      id: 11,
      name: "Allen Pugh",
    },
  },
  candidate_flight_flight_details: "AIR-INDIA-111",
  candidate_flight_country: "INDIA",
  candidate_flight_date_of_departure: "16-Dec-2023",
  candidate_flight_time_of_departure: "22:12",
  candidate_flight_date_of_arrival: "17-Dec-2023",
  candidate_flight_time_of_arrival: "09:30",
  candidate_flight_pax: 1,
  candidate_flight_sector_id: 11,
  candidate_flight_pickup_to_be_arranged: "SLA",
  candidate_flight_project_incharge: "Arun",
  candidate_flight_flight_status: "asasas",
  candidate_flight_created_at: "2023-12-04T10:33:43.000000Z",
  candidate_flight_updated_at: "2023-12-12T11:15:35.000000Z",
  candidate_flight_sector: {
    id: 11,
    name: "Allen Pugh",
  },
  candidate_flight_sector_name: "Allen Pugh",
  nationality_name: "INDIA",
  job_position_name: "OPEN",
  visa_profession_name: null,
  sector_name: "JUBAIL",
};

export function flattenObjectInObjects(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let newKey = parentKey ? `${parentKey}_${key}` : key;

      if (typeof obj[key] === "object" && obj[key] !== null) {
        result[newKey] = obj[key];
        flattenObjectInObjects(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
}
